import { useGetAccountTransactionsQuery } from "@apis/accountTransactions/useAccountTransactions"
import { DataTable } from "@components/DataTable/DataTable"
import { tableColumnsAccountTransactions } from "./tableColumnSchema"

type TAccountTransactionsProps = {
  account_id: string
}

export default function AccountTransactions({
  account_id,
}: TAccountTransactionsProps) {
  const getAccountTransactionsQuery = useGetAccountTransactionsQuery(account_id)

  return (
    <div>
      <h3>Account Transactions</h3>
      {getAccountTransactionsQuery.isError ? (
        <div className="tw:text-red-500">
          {`There was an error loading Account Transactions. Error: ${getAccountTransactionsQuery.error?.message}`}
        </div>
      ) : (
        <DataTable
          columns={tableColumnsAccountTransactions}
          data={getAccountTransactionsQuery.data ?? []}
          pending={getAccountTransactionsQuery.isPending}
        />
      )}
    </div>
  )
}
